var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import TextSkeleton from "../../Skeleton/TextSkeleton";
var PageHeadingMeta = function (_a) {
    var items = _a.items;
    if (!items) {
        return _jsx(_Fragment, {});
    }
    var renderSkeleton = function (item) {
        return (_jsx("div", __assign({ className: item.skeletonWidth }, { children: _jsx(TextSkeleton, {}) })));
    };
    return (_jsx("div", __assign({ className: "mt-1 flex flex-col sm:mt-0 sm:flex-row sm:flex-wrap gap-x-6" }, { children: items.map(function (item, i) { return (_jsxs("div", __assign({ className: "mt-2 flex items-center text-sm text-gray-500" }, { children: [_jsx(item.icon, { className: "mr-1.5 h-5 w-5 flex-shrink-0 text-gray-400", "aria-hidden": "true" }), item.skeleton
                    ? renderSkeleton(item)
                    : item.text] }), i)); }) })));
};
export default PageHeadingMeta;
